import React from 'react';
import { EmbedIcon } from './EmbedIcon';

export const Placeholder: React.FC = () => (
  <div
    className="html-embed-placeholder-wrapper"
    style={{
      padding: '16px',
    }}
  >
    <div
      className="html-embed-placeholder"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        minHeight: '400px',
        padding: '24px 16px',
        border: '2px dashed #c7d2dc',
        borderRadius: '8px',
        backgroundColor: '#ffffff',
        textAlign: 'center',
      }}
    >
      {/* Icon in circular container */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '40px',
          height: '40px',
          borderRadius: '50%',
          backgroundColor: '#f3f4f6',
          color: '#6b7280',
          marginBottom: '12px',
        }}
      >
        <EmbedIcon />
      </div>
      {/* Title */}
      <div
        style={{
          fontSize: '14px',
          fontWeight: 500,
          color: '#374151',
          marginBottom: '4px',
        }}
      >
        Embed Content
      </div>
      {/* Instruction */}
      <div
        style={{
          fontSize: '13px',
          color: '#6b7280',
        }}
      >
        Edit to add embed code, video, or iframe
      </div>
    </div>
  </div>
);
